export default function (state = {
    module: {search_string: '', list:{}, details:{}, validation:{}, options:{}},
    module_config: {},
    module_component: { list:{}, details:{}, area_ids:{}, validation:{}, options:{}, free_areas:{}, component_classes:{}},
    component_config: {},

    free_controllers: { list:{}},
    free_components: { list:{}}
}, action) {
    switch(action.type) {
        case 'MODULE_UPDATE_SEARCH_STRING':
            state.module.search_string = action.value;
        return { ...state };
        case 'MODULE_SEARCH':
            state.module.list = action.data.list;
            return { ...state };
        case 'MODULE_OPTIONS':
            state.module.options = action.data.options;
            return { ...state };
        case 'MODULE_DETAILS':
            state.module.details = action.data.record;
            state.module.options = action.data.options;
            state.module_config_params = action.data.module_config_params;
            state.module_config =  state.module.details.module_config || {};
            return { ...state };
        case 'MODULE_UPDATE_FORM':
            if (state.module_config_params && state.module_config_params[action.field]) {
                state.module_config[action.field] = action.value;
                state.module.details.module_config = state.module_config;
            } else {
                state.module.details[action.field] = action.value;
                if (state.module.validation[action.field]) {
                    state.module.validation[action.field] = {};
                }
            }
            return { ...state };
        case 'MODULE_VALIDATION_ERROR':
            state.module.validation = action.data;
            return { ...state };
        case 'MODULE_SELECTED':
            state.module.selected = action.value;
            state.module_component.selected = null;
            state.module_component.details = {};
            return { ...state };
        case 'MODULE_INSERTED':
            state.module.validation = {};
            state.module.selected = action.data.insertId;
            return { ...state };
        case 'MODULE_DESELECTED':
        case 'MODULE_UPDATED':
        case 'MODULE_DELETED':
            state.module.validation = {};
            state.module.details = {};
            state.module.selected = null;
            state.module_component.selected = null;
            state.module_component.details = {};
            state.module_component.list = {};
            state.module_config = {};
            state.module_config_params = {};
            return { ...state };
        case 'MODULE_INSERT_ERROR':
        case 'MODULE_UPDATE_ERROR':
            state.module.details = {};
            return { ...state };
        case 'MODULE_COMPONENT_DETAILS':
            //console.log(action);
            state.module_component.details = action.data.record;
            state.component_config_params = action.data.component_config_params;
            state.component_config =  state.module_component.details.component_config || {};
            console.log(state.component_config_params);


            return { ...state };
        case 'MODULE_COMPONENT_LINKED_LIST':
            state.module_component.list = action.data;
            state.free_controllers.list = null;
            state.free_controllers.req_component_interface = null;
            state.free_controllers.req_class_prop = null;
            state.free_controllers.selected = null;
            state.free_components.list = null;
            state.free_components.selected = null;
            return { ...state };
        case 'MODULE_COMPONENT_SELECTED':
            state.module_component.selected = action.value;
            state.free_controllers.list = null;
            state.free_controllers.req_component_interface = null;
            state.free_controllers.req_class_prop = null;
            state.free_controllers.selected = null;
            state.free_components.list = null;
            state.free_components.selected = null;
            state.module_component.details = {};
            return { ...state };
        case 'MODULE_COMPONENT_DESELECTED':
            state.module_component.selected = null;
            state.free_controllers.req_class_prop = null;
            state.module_component.details = {};
            state.free_controllers.list = null;    
            state.free_controllers.req_component_interface = null;
            state.free_controllers.selected = null;
            state.free_components.list = null;
            state.free_components.selected = null
            return { ...state };
        case 'MODULE_COMPONENT_FREE_AREAS':
            state.module_component.free_areas = action.data;
            return { ...state };
        case 'MODULE_COMPONENT_COMPONENT_CLASSES':
            state.module_component.component_classes = action.data;
            return { ...state };

        //module class prop for free controllers
        case 'MODULE_CLASS_PROP_SELECTED':
            state.free_controllers.req_class_prop = action.class_prop_value;
            state.free_controllers.req_component_type = action.component_type_value;
            state.free_controllers.selected = null;
            state.free_components.selected = null;
            return { ...state };
        case 'MODULE_CLASS_PROP_DESELECTED':
            state.free_controllers.list = null;
            state.free_controllers.req_class_prop = null;
            state.free_controllers.req_component_interface = null;
            state.free_controllers.selected = null;
            state.free_components.selected = null;
            return { ...state };


        //free controllers
        case 'MODULE_COMPONENT_FREE_CONTROLLERS':
            state.free_controllers.list = action.data;
            return { ...state };
        case 'FREE_CONTROLLER_SELECTED':
            state.free_controllers.selected = action.value;
            state.free_components.selected = null;
            return { ...state };
        case 'FREE_CONTROLLER_DESELECTED':
            state.free_controllers.selected = null;
            state.free_components.selected = null;
            return { ...state };

        //free components for selected free controller
        case 'MODULE_COMPONENT_FREE_COMPONENTS':
            state.free_components.list = action.data;
            return { ...state };
        case 'FREE_COMPONENT_SELECTED':
            state.free_components.selected = action.value;
            return { ...state };
        case 'FREE_COMPONENT_DESELECTED':
            state.free_components.selected = null;
            return { ...state };

        case 'MODULE_COMPONENT_UPDATE_FORM':
            console.log(action);
            console.log(state.component_config_params);
            if (state.component_config_params && state.component_config_params[action.field]) {
                state.component_config[action.field] = action.value;
                state.module_component.details.component_config = state.component_config;
            } else {
                state.module_component.details[action.field] = action.value;
            if (state.module_component.validation[action.field]) {
                state.module_component.validation[action.field] = {};
            }
            }
            return { ...state };
        case 'MODULE_COMPONENT_UPDATED':
            state.free_controllers.list = null;
            state.free_controllers.req_component_interface = null;
            state.free_controllers.req_class_prop = null;
            state.free_controllers.selected = null;
            state.free_components.list = null;
            state.free_components.selected = null;
            state.module_component.selected = null;
            state.module_component.details = {};
            return { ...state };
        case 'MODULE_COMPONENT_CLEARED':
            state.free_controllers.list = null;
            state.free_controllers.req_component_interface = null;
            state.free_controllers.req_class_prop = null;
            state.free_controllers.selected = null;
            state.free_components.list = null;
            state.free_components.selected = null;
            state.module_component.selected = null;
            state.module_component.details = {};
            return { ...state };
        default:
            break;
    }
    return state;
}

